var exports = {
  "x6": "x4ddf2309--a8a908--button",
  "wK": "x4ddf2309--a8a908--pin-icon",
  "DD": "x4ddf2309--a8a908--title",
};

module.exports = exports;
